import { z } from 'zod';
import { zDaemonDecisionReviewRequest } from '../../generated/api/zod.gen.js';

/** The review body plus which button was pressed; rejecting needs a reason the proposer can act on. */
export const reviewSchema = zDaemonDecisionReviewRequest
  .extend({ action: z.enum(['approve', 'reject']) })
  .refine((value) => value.action === 'approve' || (value.notes?.trim().length ?? 0) > 0, {
    path: ['notes'],
    message: 'Say why you are rejecting it, so the proposer can fix it',
  });
